import { ClientOptions, FlagBaseContext, Team } from '@getvim/feature-flags/client';
import { createFeatureFlagContext } from '@getvim/feature-flags/react';
import { isEmpty, trim } from 'lodash-es';

interface EligibilityFlagContext extends FlagBaseContext {
  organizationId?: number;
}

const { FeatureFlagProvider, useFeatureFlag } = createFeatureFlagContext<EligibilityFlagContext>();

const {
  rollout__key: rolloutKey,
  VIM_feature_flags__proxy_url: proxyUrl,
  VIM_feature_flags__unify_key: unifyKey,
} = globalThis.$vim_environment ?? {};

const ffClientOptions: ClientOptions = {
  team: Team.PatientInsights,
  namespace: 'eligibility',
  rolloutKey: rolloutKey,
  proxyUrl: proxyUrl,
  unifyKey: isEmpty(trim(unifyKey)) ? undefined : unifyKey,
  defaultContext: {},
};

export { FeatureFlagProvider, ffClientOptions, useFeatureFlag };

export { Team } from '@getvim/feature-flags/client';
